import { Router, ActivatedRoute } from '@angular/router'
import { Location } from '@angular/common'

export class AngularService {
    constructor(
        public router: Router,
        public location: Location,
    ) {}

    public getQueryParam(key: string, activatedRoute: ActivatedRoute) {
        return activatedRoute.snapshot.queryParams[key] || ''
    }
    public setQueryParams(params: any, activatedRoute: ActivatedRoute, preserveExistingParams: boolean = true) {
        var newParams = params
        for (var prop in newParams) {
            if (newParams[prop] === '') {
                newParams[prop] = null
            }
        }

        if (preserveExistingParams) {
            newParams = Object.assign(Object.assign({}, activatedRoute.snapshot.queryParams), params)
        }

        activatedRoute.snapshot.queryParams = newParams

        setTimeout(() => {
            this.router.navigate([], {
                queryParams: newParams,
                relativeTo: activatedRoute,
                replaceUrl: true,
            })
        })
    }
    public convertStyleToAngularStyle(style: string) {
        var result = {} as any
        if (style) {
            var attributes = style.split(';')

            for (var i = 0; i < attributes.length; i++) {
                var entry = attributes[i].split(':')
                result[entry.splice(0, 1)[0]] = entry.join(':')
            }
        }

        return result
    }
}
